export default {
  clarity: '/clarity',
  clarityAI: '/clarity/mozzie-ai',
};
